module.exports = {"id":"216271","name":"Joost van Aken","rating":"71","photo":"./data/images/photos/1/216271.png","club":{"name":"Sheffield Wed.","logo":"./data/images/clubs/SheffieldWed..png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JoostvanAken0.json
// module id = 2124
// module chunks = 0